import React from 'react';
import { isMobile } from '@helpers/EnvHelper';
import { isEmpty as _isEmpty } from 'lodash';

/* 메인 키비쥬얼 타입:이미지 */
const ImageBanner = ({ data, navigate }) => {
  const btnCenterClass =
    'bottom-[9%] xl:bottom-[128px] left-1/2 -translate-x-1/2';
  const btnLeftClass =
    'bottom-[9%] xl:bottom-[91px] left-[20px] xl:left-[50px]';
  const btnRightClass =
    'bottom-[9%] xl:bottom-[39px] right-[20px] xl:right-[40px]';

  const onClickBannerBtn = (weblink, molink, btnMove) => {
    let link = isMobile() ? molink : weblink;
    if (_isEmpty(link)) {
      return;
    }
    if (
      !link.startsWith('/') &&
      !(link.startsWith('https') || link.startsWith('http'))
    ) {
      link = 'http://' + link;
    }
    if (btnMove === 'move') {
      if (link.startsWith('/')) {
        navigate(link);
      } else {
        window.open(link, '_self');
      }
    } else {
      window.open(link, '_blank');
    }
  };

  return (
    <>
      <div className="absolute w-full h-full z-30 left-1/2 top-1/2 -translate-x-1/2 -translate-y-1/2 container">
        {data.btnLocation == 'all' && (
          <button
            className="w-full h-full cursor-pointer z-40"
            onClick={() =>
              onClickBannerBtn(data.btnWebUrl, data.btnMoUrl, data.btnMove)
            }
          ></button>
        )}

        {data.btnLocation !== 'all' && (
          <button
            className={`flex items-center gap-x-[12px] xl:gap-x-[20px] px-[18px] xl:px-[40px] py-[11px] xl:py-[26px] border xl:border-[3px] border-white rounded-full text-white absolute text-[14px] xl:text-[20px] font-Pretendard font-bold 
                    ${
                      data.btnLocation.indexOf('left') !== -1
                        ? btnLeftClass
                        : data.btnLocation.indexOf('center') !== -1
                        ? btnCenterClass
                        : btnRightClass
                    }`}
            style={{ backgroundColor: data.btnColor }}
            onClick={() =>
              onClickBannerBtn(data.btnWebUrl, data.btnMoUrl, data.btnMove)
            }
          >
            <span style={{ color: data.btnNameColor }}>{data.btnName} </span>
            <i className="icon-arrow-right-w text-[10px] xl:text-[12px]" />
          </button>
        )}
      </div>
    </>
  );
};

export default ImageBanner;
